export abstract class LiveQuery {
    protected subscription: any | null

    protected subscripted: boolean

    protected objectLib: any

    protected objectId: string

    protected callback: (obj: any) => void

    // eslint-disable-next-line no-undef
    protected restartCallBack: VoidFunction

    protected async createLiveQuery() {
        if (!this.subscripted) {
            this.subscription.on('open', () => {
                this.subscripted = true
            })
            this.subscription.on('close', () => {
                this.subscription = null
                this.subscripted = false
            })
            this.subscription.on('error', () => {
                this.subscription = null
                this.subscripted = false
                setTimeout(async () => {
                    this.restartCallBack()
                }, 4000)
            })
        }
    }

    constructor(objectId: string, callback: (obj: any) => void) {
        if (!objectId) {
            throw new Error('[LiveQuery] constructor error: objectId must be defined')
        }
        this.objectId = objectId
        this.subscripted = false
        this.callback = callback
        this.restartCallBack = () => {
            console.error('Should not be printed')
        }
    }

    public unsubscribe() {
        if (!this.subscripted && this.subscription) this.subscription.unsubscribe()
    }
}
